import SearchContnet from "@modules/study/search/content";
import { LayoutMain } from "@unisearch/theme/layout";
import React from "react";

const SearchContentPage = () => {
  return (
    <LayoutMain title="Search Content">
      <SearchContnet />
    </LayoutMain>
  );
};

export default SearchContentPage;
